import { FC } from 'react'
import cn from './index.module.css'
import { useGetSettings } from '@pages/CoursesCatalog/tabs/CatalogCoursesTab/hooks/getPlatformSettings'
import SecondaryButton from '@pages/Admin/CourseSettings/components/SecondaryButton/SecondaryButton'
import classNames from 'classnames'

interface ICatalogHeader {
  className?: string,
  inputImage?: string
}

const CatalogHeader: FC<ICatalogHeader> = ({ className, inputImage }) => {
  const { getSettings } = useGetSettings()
  const image = getSettings('catalogImage') ?? ''
  const text = getSettings('catalog_rightText') ?? ''
  const textLink = getSettings('catalog_rightTextLink') ?? ''
  const button = getSettings('catalog_buttonName') ?? ''
  const buttonLink = getSettings('catalog_buttonLink') ?? ''

  const onNavigate = (text: string) => {
    if (text) window.location.href = text
  }

  return (
    <div className={classNames(cn.header, className)}>
      {text && (
        <SecondaryButton
          className={cn.buttonLeft}
          onClick={() => onNavigate(textLink)}
        >
          {text}
        </SecondaryButton>
      )}
      {image && (
        <img
          className={cn.icon}
          src={inputImage? inputImage : (process.env.REACT_APP_PATH_FILE + image)}
          alt="catalog image"
        />
      )}
      {button && (
        <SecondaryButton
          className={cn.buttonRight}
          onClick={() => onNavigate(buttonLink)}
        >
          {button}
        </SecondaryButton>
      )}
    </div>
  )
}

export default CatalogHeader
